import { render, staticRenderFns } from "./CarrierDestinationInfoCard.vue?vue&type=template&id=3dd8b5c3&scoped=true&"
import script from "./CarrierDestinationInfoCard.vue?vue&type=script&lang=js&"
export * from "./CarrierDestinationInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd8b5c3",
  null
  
)

export default component.exports